<template>
  <div v-if="visible" class="announcement-banner" :class="bannerClass">
    <div class="announcement-banner__content" v-dompurify-html="renderedMessage"></div>
    <button
      v-if="banner.dismissible"
      class="announcement-banner__dismiss"
      type="button"
      @click="dismissBanner"
      aria-label="Dismiss announcement banner"
    >
      Dismiss
    </button>
  </div>
</template>

<script>
import { bannerClassForSeverity, isAnnouncementActive, renderAnnouncementMarkup } from "@/utils/announcementBanner";

export default {
  name: "SystemAnnouncementBanner",
  props: {
    banner: {
      type: Object,
      default: () => ({}),
    },
    storageKey: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      dismissedBannerId: localStorage.getItem(this.storageKey) || "",
    };
  },
  computed: {
    renderedMessage() {
      return renderAnnouncementMarkup(this.banner?.message);
    },
    isActive() {
      return isAnnouncementActive({
        ...this.banner,
        message: this.renderedMessage,
      });
    },
    visible() {
      if (!this.isActive) return false;
      if (!this.banner?.dismissible) return true;
      return !this.banner?.bannerId || this.dismissedBannerId !== this.banner.bannerId;
    },
    bannerClass() {
      return bannerClassForSeverity(this.banner?.severity);
    },
  },
  watch: {
    storageKey(newKey) {
      this.dismissedBannerId = localStorage.getItem(newKey) || "";
    },
    "banner.bannerId"() {
      this.dismissedBannerId = localStorage.getItem(this.storageKey) || "";
    },
  },
  methods: {
    dismissBanner() {
      if (!this.banner?.dismissible || !this.banner?.bannerId) return;
      localStorage.setItem(this.storageKey, this.banner.bannerId);
      this.dismissedBannerId = this.banner.bannerId;
    },
  },
};
</script>

<style scoped>
.announcement-banner {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 10px 14px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.12);
}

.announcement-banner--info {
  background: #0f4c81;
  color: #fff;
}

.announcement-banner--warning {
  background: #8a5a00;
  color: #fff;
}

.announcement-banner--negative {
  background: #8f1d21;
  color: #fff;
}

.announcement-banner__content {
  flex: 1;
  min-width: 0;
}

.announcement-banner__content :deep(p) {
  margin: 0;
}

.announcement-banner__content :deep(p + p),
.announcement-banner__content :deep(ul),
.announcement-banner__content :deep(ol),
.announcement-banner__content :deep(blockquote),
.announcement-banner__content :deep(pre) {
  margin-top: 0.4rem;
}

.announcement-banner__content :deep(a) {
  color: inherit;
  text-decoration: underline;
}

.announcement-banner__dismiss {
  border: 1px solid rgba(255, 255, 255, 0.4);
  border-radius: 999px;
  background: transparent;
  color: inherit;
  cursor: pointer;
  flex-shrink: 0;
  font-size: 0.85rem;
  padding: 4px 10px;
}

.announcement-banner__dismiss:hover {
  background: rgba(255, 255, 255, 0.12);
}
</style>
